import { Component, OnInit, OnDestroy, ElementRef, ViewChild } from '@angular/core';
import { MasterActions, GridHeader, Authors, defaultAuthors, GridHeaderEx } from 'src/app/model';
import { Subscription } from 'rxjs';
import { MsgService, AuthorsService, UtilService,UserType, AppConfigService } from 'src/app/service';


@Component({
  selector: 'app-authors',
  templateUrl: './authors.component.html',
  styleUrls: ['./authors.component.scss']
})
export class AuthorsComponent implements OnInit, OnDestroy, MasterActions {
  @ViewChild('profile_image', { static: true }) specDoc: ElementRef;
  private subscription = new Subscription();
  public cols: Array<GridHeader> = [];
  public dataArray: Array<Authors>;
  public selectedRows: Array<any> = [];
  public selectedColumns: Array<GridHeader>;
  public dataObj: Authors = defaultAuthors;
  public isDeleteDetails = false;
  public isAddDetails = false;
  public isEditDetails = false;
  public isViewDetails = false;
  public editCallTypeList: any = {};


  public url : string | ArrayBuffer; 

  public set isEditShow(value: boolean) {
    this.isEditDetails = value;
    this.isAddDetails = value;
  }

  public get isEditShow() {
    return this.isEditDetails || this.isAddDetails;
  }

  public get dlgHeader() {
    return (this.isViewDetails ? 'View ' : (this.isEditDetails ? 'Edit ' : 'Add ')) + this.pageName;
  }

  /** grid columns and data fields */
  private columnsConfig: Array<GridHeaderEx> = [
    { field: 's_no', header: 'S No', isVisible: true, isDefault: true },
    { field: 'author_id', header: 'Id', isVisible: false, isDefault: true },
    // { field: 'author_code', header: 'Author Code', isVisible: true, isDefault: true },
    { field: 'author_name', header: 'Author Name', isVisible: true, isDefault: true },
    { field: 'profile_image', header: 'Author Image', isVisible: true, isDefault: true },
    { field: 'status', header: 'Actions', isVisible: true, isDefault: true },
  ];

  public get pageName() {
    return this.dataService.pageName;
  }
  public get isCreator() {
    return this.util.getUserRole === UserType.Creator;
  }
  constructor(
    private msgSvc: MsgService,
    public util: UtilService,
    private config: AppConfigService,
    private dataService: AuthorsService
  ) { }

  ngOnInit() {
    this.cols = this.columnsConfig.filter(i => i.isVisible)
      .map((e: GridHeaderEx) => {
        return { field: e.field, header: e.header };
      });

    this.selectedColumns = this.columnsConfig.filter(i => i.isVisible && i.isDefault)
      .map((e: GridHeaderEx) => {
        return { field: e.field, header: e.header };
      });
    this.dataService.getDataRecords();
    this.subscription.add(
      this.dataService.dataList.subscribe((data) => {
        this.dataArray = [];
        if (data.length) {
          this.dataArray = data.map((e, indx) => {
            e.s_no = indx + 1;
            return e;
          });
        } else {
          this.msgSvc.addInfoMsg({ summary: this.pageName, detail: 'No data exit' });
        }
      }));
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

	public fileUpload(event) {
		// const file = event.target.files[0];
		// this.dataObj.profile_image = file;

    if (event.target.files && event.target.files[0]) {
      var reader = new FileReader();

      reader.readAsDataURL(event.target.files[0]); // read file as data url

      reader.onload = (event) => { // called once readAsDataURL is completed
        this.url = event.target.result;
        console.log(event.target.result);
      }
      const file = event.target.files[0];
      this.dataObj.profile_image = file;
    }
	}

  public viewImage(file: string) {
    return this.config.ipAddress + 'uploads/profile_image/' + file;
  }

  public editData(event) {
    this.dataObj = Object.assign({}, event ? event : defaultAuthors);
    if (event == null) {
      this.isAddDetails = true;
    } else {
      this.isEditDetails = true;
    }
  }

  public updateData() {
    if (this.isAddDetails) {
      this.createDetails();
    } else {
      this.updateCallType();
    }
  }

  public createDetails() {
    this.dataService.addData(this.dataObj).subscribe((data) => {
      if (data) {
        this.dataService.getDataRecords();
      }
    }, err => {
      this.msgSvc.addErrorMsg(err);
    });
    this.isAddDetails = false;
    this.resetFormData();
  }

  public cancelEditDlg() {
    this.resetFormData();
  }

  private resetFormData() {
    this.isViewDetails = false;
    this.isAddDetails = false;
    this.isEditDetails = false;
    this.url = undefined;
  }
  public updateCallType() {
    this.dataService.updateData(this.dataObj).subscribe((data) => {
      this.dataService.getDataRecords();
    });
    this.isEditDetails = false;
    this.resetFormData();
  }

  public deleteDetails() {
    this.dataService.deleteData(this.dataObj.author_id).subscribe((data) => {
      this.dataService.getDataRecords();
      this.resetFormData();
    });
    this.isDeleteDetails = false;
  }

  public deleteData(obj: Authors) {
    this.dataObj = obj;
    this.isDeleteDetails = true;
  }

  public viewData(obj: Authors) {
    this.dataObj = obj;
    this.isViewDetails = true;
  }

  public updateStatus(obj: Authors) {
    this.dataService.updateStatus(obj);
  }
}
